<template>
  <div class="home">
    <LevellingView
      :evaluation="isEvaluation"
      @openDocument="openDocument"
      @setLevel="setLevel"
      @editLevel="editLevel"
    ></LevellingView>
  </div>
</template>

<script>
import LevellingView from "@/components/levelling/cLevellingView";

export default {
  name: "vLevelling",
  components: {
    LevellingView,
  },
  computed: {
    isEvaluation() {
      return this.$route.query.evaluation === "true";
    },
  },
  methods: {
    openDocument(item) {
      this.$emit("openDocument", item);
    },
    setLevel(item) {
      this.$router.push({
        name: "evaluate",
        params: { docReference: item.system_number },
      });
    },
    editLevel(item) {
      this.$router.push({
        name: "evaluate",
        params: { docReference: item.system_number },
      });
    },
  },
};
</script>
